import { type GetListParams } from "react-admin";

import { createApiClient } from "@/api";
import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";
import { type BaseListFilter } from "@/types/filters";
import { type DataProviderSchema } from "@/utils";
import { getLocalFilteredSortedList } from "@/utils/listParams";

const apiClient = createApiClient("jsonld");

const BASE_URL = "/api/vpn/tickets";

const fetchTicketsListData = async (params: GetListParams) => {
  const typedFilter = params.filter as BaseListFilter;
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    [CLIENT_SEARCH_SOURCE]: _,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    per_page: _perPage,
    ...restFilters
  } = typedFilter;
  const { data } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        page: params.pagination?.page,
        ...restFilters,
      },
    },
  });
  return {
    data: data?.["hydra:member"] ?? [],
    total: data?.["hydra:totalItems"] ?? 0,
  };
};

export const ticketsSchema: DataProviderSchema<"Ticket", "jsonld"> = {
  list: getLocalFilteredSortedList(fetchTicketsListData),
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("Ticket not found");

    return { data };
  },
};
